import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import loginSlice from "./loginSlice";
import registerSlice from "./registerSlice";
import cartSlice from "./cartSlice";
import productSlice from "./productSlice";
import orderSlice from "./orderSlice";
import categorySlice from "./categorySlice";
import shopSlice from "./shopSlice";
import errorSlice from "./errorSlice";

const rootReducer = combineReducers({
  login: loginSlice,
  register: registerSlice,
  user: userSlice,
  cart: cartSlice,
  products: productSlice,
  order: orderSlice,
  category: categorySlice,
  shop: shopSlice,
  error: errorSlice,
});

export default rootReducer;
